import { render } from "./PageTabs.vue?vue&type=template&id=5fcda996&scoped=true"
import script from "./PageTabs.vue?vue&type=script&lang=js"
export * from "./PageTabs.vue?vue&type=script&lang=js"

import "./PageTabs.vue?vue&type=style&index=0&id=5fcda996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcda996"]])

export default __exports__